export const formatter = new Intl.NumberFormat('nl', {
  style: 'currency',
  currency: 'EUR',
});

const wholeFormatter = new Intl.NumberFormat('nl', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Format currency according to NL conventions.
 * Will format integer numbers without fractional suffix.
 *
 * @example
 * format(1) // => '€ 1'
 * format(1.2) // => '€ 1.20'
 *
 * @param value
 */
export function format(value: number): string {
  // Format the currency without digits if the value has no fractional component
  if (value % 1 === 0) {
    return wholeFormatter.format(value);
  }

  // Otherwise format with the currency symbols
  return formatter.format(value);
}
